// This component is part of @azure/msal-angular and can be imported and bootstrapped
import { Component, OnInit } from "@angular/core";
import { MsalService } from '@azure/msal-angular';

@Component({
	selector: 'redirection-sso', // Selector to be added to index.html
	template: ''
})
export class MsalRedirectComponent implements OnInit {

	constructor(private authService: MsalService) { }

	ngOnInit(): void {
		this.authService.instance.handleRedirectPromise().then((result) => {
			if (result) {
				this.authService.instance.setActiveAccount(result.account);
			}
		});
	}

}
